import React from 'react'

import 'app/match/applicationReportPDF/components/Layout/Container/style.scss'

function Container(props) {
  return <div className="custom-container">{props.children}</div>
}

export default Container
